export default function getSoftwareName(os: string) {
    let getSoftwareName = 'linux';
    const osName = os.toLowerCase();

    if (osName.includes("windows")) {
        getSoftwareName = 'windows';
    } else if(osName.includes("and")) {
        getSoftwareName = 'android';
    } else if(osName.includes("ios")) {
        getSoftwareName = 'ios';
    } else if(osName.includes("mac")) {
        getSoftwareName = 'mac';
    }

    return getSoftwareName;
}